// extracted by mini-css-extract-plugin
module.exports = {"seriesDetail":"BF","header":"BG","headerUnderTrailer":"BH","leftHeader":"BI","buttonsWrapper":"BJ"};